import "./style/style2.css"

import Footer from './Footer';


import PhoneMockup from './images/Phone-Mockup.png';
import DishopFid1 from './images/dishop/home-ux-ui-dishop.png';
import DishopFid2 from './images/dishop/products-ux-ui-dishop.png';
import DishopFid3 from './images/dishop/free-products-ux-ui-dishop.png';
import DishopFid4 from './images/dishop/congrats-ux-ui-dishop.png';
import UserPersonaEN from './images/User-Persona-Client-EN.jpg';
import UserFlowFr from './images/User-Flow-Dishop-Fid.jpg';
import UserJourneyEN from './images/User-Journey-Dishop-EN.jpg';
import GameUXImage from './images/Game-UX.jpeg';
import MinBar from './images/min-amount-bar.svg';
import StarIcon from './images/Star-icon.svg';
import SideButton from './images/Side-button.svg';
import giftIcon from './images/gift-icon.png';


import freeProductsPageVideo from './images/dishop/free-products-ux-ui.mov'
import productsPageVideo from './images/dishop/credit-score-non-visible-ux-ui.mov'
import sliderVideo from './images/dishop/ux-ui-slider-food-app.mov'
import congratsVideo from './images/dishop/congrats-screen-ux-ui.mov'

import folioDishop from './images/UX-UI-Project-Mobile-App-Dishop-Food.png'
import arrowIcon from './images/arrow.svg'


import ProjectNav from "./Project_Nav";

import { useState, useEffect } from 'react';

import { Link } from 'react-router-dom';

import ScrollToTop from './ScrollToTop';


export default function ProjectDishop() {


    const [TransY, setTransY] = useState('translateY(333px)');
    const [OpacityB, setOpacityB] = useState('0.0');

    useEffect(() => {
        // This will be called after the initial render
        setOpacityB('1');
        setTransY('translateY(0px)');

    }, []);

    const onMouseClickHandler2 = async () => {

    }

    const ColoredLine = ({ color }) => (
        <hr
            style={{
                backgroundColor: color,
                height: 2
            }}
        />
    );

    return (
        <ScrollToTop>
            <div class="projectPage" id="top">

                {/* Prvious and T0p Arrows*/}
                <div style={{ position: 'fixed', top: '13px', left: '13px', 'z-index': '55', opacity: OpacityB }}><div style={{ position: 'absolute', transform: 'rotate(-134deg)' }}>
                    <Link to="/" style={{ 'text-decoration': 'none' }}><div class='iconCircle'><img src={arrowIcon} style={{ margin: '0px', transform: 'translate(-2px,-3px)' }} /></div></Link></div></div>
                <div style={{ position: 'fixed', bottom: '67px', right: '67px', 'z-index': '55', opacity: OpacityB }}><div style={{ position: 'absolute', transform: 'rotate(-45deg)' }}><a href="#top" style={{ cursor: 'default' }}><div class='iconCircle'><img src={arrowIcon} style={{ margin: '0px', transform: 'translate(-1px,-2px)' }} /></div></a></div></div>

                <div className="bar" style={{ opacity: OpacityB }}><img src={folioDishop} style={{ opacity: OpacityB }}></img></div>
                <div className="bar2" style={{ backgroundColor: '#08a888', transform: TransY, opacity: OpacityB, position: 'sticky', top: 0 }}>

                    <div className="projectHeader">

                        <div className="textBoxLeft">
                            <div className="smallText">Client:</div>
                            <div className="projectTitle">Dishop<br /></div>
                        </div>

                        <div className="projectTitleRight">
                            <div className="smallText">Summary</div>
                            <div className="projectTitle">
                                I designed and implemented the loyalty system for the mobile food ordering app ‘Dishop’.
                            </div>
                        </div>
                    </div>

                    <div className="projectHeader">

                        <div className="textBoxLeft">
                            <div className="smallText">Role:</div>
                            <div className="projectTitle">UX Design<br />UI Design</div>
                        </div>

                        <div className="projectTitleRight">
                            <div className="smallText">Tools</div>
                            <div className="projectTitle">Adobe XD, Miro, Figma, Adobe Photoshop</div>
                        </div>

                    </div>
                </div>
                <div class="Rido" style={{ top: '0px', 'background-color': '#ffffff', opacity: '1', 'z-index': '-2' }}></div>

                <div class="ProjectContainer" style={{ transform: TransY, opacity: OpacityB }}>

                    <div class="section">
                        <div class="oneColumnIntro">
                            <h2>Introduction</h2>
                            <div class="IntroTexts">
                                Dishop is a mobile app which allows restaurant owners and franchises to offer their own branded online ordering and delivery service. Customers can place orders for delivery or pickup (click and collect). The platform also includes design tools so businesses can customize their ordering website to reflect their brand identity.
                            </div>
                        </div>
                    </div>

                    <div class="sectionDarker">
                        <div class="sectionDarker" style={{ maxWidth: '1444px' }}>
                            <div class="sectionColumn"></div>

                            <div class="sectionColumn">
                                <div class="title"><h2>Problem Statement</h2></div>
                                <p>
                                    In the fast-paced landscape of online food ordering, Dishop's mobile application faced a significant challenge:
                                    <strong> the lack of a comprehensive loyalty system.</strong>
                                </p>
                                <p>
                                    Despite its operational efficiency, the app <strong>struggled to retain customers and drive repeat purchases</strong>.
                                    This gap created a competitive disadvantage, especially compared to major players like McDonald's and Burger King,
                                    who leverage well-established loyalty programs to <strong>attract and retain users</strong>.
                                </p>
                                <p>
                                    It became essential to integrate a robust loyalty feature into the mobile experience to increase user engagement,
                                    <strong> boost sales</strong>, and solidify the app’s position in the demanding market of food delivery and takeaway services.
                                </p>
                            </div>
                        </div>
                    </div>


                    <div class="insidePictures">

                        <div class="phoneMock"><img src={PhoneMockup} alt="Phone-Mockup" /><div class="phoneScree"><img src={DishopFid1} /></div></div>
                        <div class="phoneMock"><img src={PhoneMockup} alt="Phone-Mockup" /><div class="phoneScree"><img src={DishopFid2} /></div></div>
                        <div class="phoneMock"><img src={PhoneMockup} alt="Phone-Mockup" /><div class="phoneScree"><img src={DishopFid3} /></div></div>
                        <div class="phoneMock"><img src={PhoneMockup} alt="Phone-Mockup" /><div class="phoneScree"><img src={DishopFid4} /></div></div>

                        {/* <div class="phoneScreen"><img src={PhoneMockup} alt="Phone-Mockup"/></div>*/}

                    </div>


                    <div className="section">
                        <div className="objectifsColumn">
                            <h2>Project Objectives</h2>
                        </div>

                        <div className="objectifsColumn">
                            <div className="point">
                                <div className="number">1</div>
                                <div>Enhance user loyalty through meaningful engagement</div>
                            </div>

                            <div className="point">
                                <div className="number">2</div>
                                <div>Improve overall customer satisfaction by optimizing the experience</div>
                            </div>

                            <div className="point">
                                <div className="number">3</div>
                                <div>Encourage repeat purchases through user-centric design patterns</div>
                            </div>

                            <div className="point">
                                <div className="number">4</div>
                                <div>Integrate gamification mechanisms (e.g. point scoring) to boost interactivity</div>
                            </div>

                            <div className="point">
                                <div className="number">5</div>
                                <div>Increase user retention rates by fostering continuous value delivery</div>
                            </div>
                        </div>
                    </div>
                    {/*<div class="totalWidth"><ColoredLine color="#3d3d3d" /></div>*/}

                    <div class="GrayBG">

                        <div class="commentSection">
                            <div class="smallTitle">
                                Our Solution – Dishop Loyalty
                                <div class="bigTitle">A Gamified and Rewarding Loyalty System</div>
                            </div>
                        </div>

                        <div class="commentSection">
                            <div class="commentColumnScreen">
                                   <div class="phoneMock">
                                        <img src={PhoneMockup} alt="Phone-Mockup" />
                                        <div class="phoneScree">
                                            <img src={DishopFid1} />
                                        </div>
                                    </div>
                            </div>
                            <div class="commentColumn">
                                <h3>Homepage – ‘My Loyalty’ Card</h3>
                                <p>
                                    Since the loyalty system was a newly introduced feature in the app and needed to
                                    <strong> become part of the user’s routine</strong>, placing it on the homepage was the most effective design decision.
                                </p>
                                <p>
                                    Displaying the loyalty points along with a minimum purchase progress bar helps to gamify the experience,
                                    thereby encouraging users to <strong>accumulate more points</strong> (increase their score). At the same time, it incentivizes them
                                    to redeem their points, which is <strong>tied to a minimum purchase requirement</strong>.
                                </p>
                                <p>
                                    Users can also access their loyalty points page <strong>at any time via the ‘Star’ button</strong> located at the center of the bottom navigation bar.
                                </p>
                            </div>
                        </div>

                        {//‘Free Products’ Page
                        }

                        <div class="commentSection">
                            <div class="commentColumn">
                                <h3>‘Free Products’ Page</h3>
                                <p>
                                    <i>
                                        “On this page, I can <strong>redeem my loyalty points</strong> and add one or more free products to my current order.”
                                    </i>
                                </p>
                                <p>
                                    Once the shopping cart has been filled with <strong>the required minimum order amount</strong> (value ≥ 30€),
                                    users can then add free products and proceed directly to the checkout page.
                                </p>
                            </div>
                            <div class="commentColumnScreen">

                                     <div class="phoneMock">
                                        <img src={PhoneMockup} alt="Phone-Mockup" />
                                        <div class="videoPhoneScreen">
                                        <video controls="true" autoplay="true" loop="true" muted width="100%" src={freeProductsPageVideo} type="video/mp4" />
                                        </div>
                                    </div>


                                {/* <div class="phone-video">
                                    <video controls="true" autoplay="true" loop="true" muted width="100%" src={freeProductsPageVideo} type="video/mp4" />
                                </div> */}
                            </div>
                        </div>


                        { // 'Order' Page
                        }
                        <div class="commentSection">

                            <div class="commentColumnScreen" style={{marginBottom: '53px'}}>

                                <div class="phoneMock">
                                    <img src={PhoneMockup} alt="Phone-Mockup" />
                                    <div class="videoPhoneScreen">
                                        <video controls="true" autoplay="true" loop="true" muted width="100%" src={productsPageVideo} type="video/mp4" />
                                    </div>



                                </div>

                            </div>
                  

                            <div class="commentColumn">
                                <h3>'Order' Page (User Problem)</h3>
                                <p><i>“I’m adding meals and unlocking free products!”</i></p>
                                <p>After implementing the loyalty card and the ability to redeem points for free products, <strong>a persistent issue remained on the order page</strong>. When users landed directly on this page, the <strong>loyalty point system was no longer visible</strong>.</p>
                                <div class="speech-bubble">
                                    <p><i>A pop-up before checkout reminding users to redeem free products was not enough, as the goal was to actively encourage users to add more meals on the order page itself.</i></p>
                                </div>
                            </div>
                        </div>

                        {/* A Bit of Fun Inspiration! */}
                        <div class="sectionDarkerX" style={{ flexDirection: 'column', gap: '0px', margin: '0 0 33px 0', padding: '55px 0 0 0' }}>
                            <div class="bigTitle" style={{ color: "#dedede", marginBottom: '-54px' }}>A Bit of Fun Inspiration!</div>

                            <div class="sectionDarkerX">
                                <div class="sectionColumn" id="gameText">
                                    <p>To address this challenge, I explored the idea of integrating a <strong>visual reminder of the loyalty system</strong> directly within the product order page, allowing users to <strong>see whether they’ve reached the threshold</strong> to unlock free items while they continue adding meals to their cart.</p>
                                    <p>The typical app user is already <strong>familiar with mobile games</strong>, and therefore accustomed to ‘progress bars’—whether it’s a health bar or an <strong>experience points bar</strong> that unlocks in-game items.</p>

                                    <div class="barGraphics">
                                        <img src={StarIcon} height="32px" style={{ marginLeft: "31px" }} />
                                        <div class="plusIcon">+</div>
                                        <img src={MinBar} height="27px" style={{ marginLeft: "31px" }} />
                                        <div class="plusIcon">+</div>
                                        <img src={giftIcon} height="45px" style={{ marginLeft: "31px" }} />
                                        <div class="plusIcon">=</div>
                                        <img src={SideButton} height="45px" style={{ marginLeft: "31px" }} />
                                    </div>
                                </div>

                                <div class="sectionColumnSM" id="gameImage">
                                    <div class="commentColumn">
                                        <div class="phoneMockSM">
                                            <img src={PhoneMockup} alt="Phone-Mockup" />
                                            <div class="phoneScree">
                                                <img src={GameUXImage} alt="Game-UX-Image" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        {//‘Order’ Page Version 2
                        }

                        <div class="commentSection">

                            <div class="phoneMock">
                                <img src={PhoneMockup} alt="Phone-Mockup" />
                                <div class="videoPhoneScreen">
                                    <video controls="true" autoplay="true" loop="true" muted width="100%" src={sliderVideo} type="video/mp4" />
                                </div>
                            </div>

                            <div class="commentColumn">
                                <h3>‘Order’ Page Version 2</h3>
                                <p>Upon landing on the Order' page, the user now sees a small <strong>button with a star icon</strong> positioned on the right edge of the screen.</p>
                                <p>When clicked, a side panel appears, informing the user <strong>whether they have reached the minimum purchase threshold</strong> required to unlock free products.</p>
                                <p>This panel can be toggled on or off at the user’s convenience. Once eligible, the user can then choose to <strong>add free products by tapping the 'Gifts' icon</strong>, which redirects them to the “Free Products” screen.</p>
                            </div>

                        </div>


                        {//‘Congratulations’ Pop-up
                        }
                        <div class="commentSection">

                            <div class="commentColumn">
                                <h3>‘Congratulations’ Pop-up</h3>
                                <p><i>“I finalize my order and earn loyalty points!”</i></p>
                                <p>To encourage users to order through the app, a congratulatory message is displayed to <strong>make them feel valued and rewarded</strong> for placing an order at the restaurant.</p>
                                <p>As the final interaction in the flow, the 'Congratulations' pop-up also serves as a <strong>reminder of the user’s loyalty points</strong>, subtly motivating them to <strong>return to the app and redeem free products</strong> on their next order.</p>
                            </div>

                               <div class="commentColumnScreen">
                                         <div class="phoneMock">
                                <img src={PhoneMockup} alt="Phone-Mockup" />
                                <div class="videoPhoneScreen">
                                    <video controls="true" autoplay="true" loop="true" muted width="100%" src={congratsVideo} type="video/mp4" />
                                </div>
                            </div>
                            </div>


         

                 

                            
                            
                        </div>

                    </div>


                    {//Research Processes
                    }

                    <div class="smallTitle">Research and Process</div>
                    <div class="bigTitle" style={{fontSize: '43px'}}>Free Products Flatten Customers <br />and Make Them Come Back</div>

                    <div class="section">
                        <div class="sectionColumn">
                        </div>

                        <div class="sectionColumn">
                            <div class="title"><h2>User Interviews</h2></div>
                            <p>I conducted interviews to gather information on the user experience with the Dishop mobile app, as well as <strong>their interests and expectations regarding loyalty programs</strong>.</p>
                            <p>By asking users about the frequency of using food delivery apps and their specific experience with Dishop, I was able to <strong>identify the strengths and pain points</strong> of the current app.</p>
                            <p>Additionally, by exploring their past experiences with <strong>other loyalty programs</strong>, like those offered by McDonald's or Burger King, I understood <strong>the features they appreciate and the motivations</strong> that encourage users to participate in such programs. These insights allowed me to design a loyalty system tailored to the needs and preferences of Dishop app users.</p>
                        </div>
                    </div>

                    <div class="sectionDarker">
                        <div class="oneColumn">
                            <div class="title"><h2>Conceptualization</h2></div>
                            <p>Based on the results of the research and interviews, I created a <strong>user persona</strong> that represents the typical user, with their background and needs.</p>

                            <img src={UserPersonaEN} alt="UserPersonaEN" />

                            <br /><br /><br />
                            <div class="title"><h2>User Journey</h2></div>
                            <p>After becoming familiar with our typical Persona, it was time to <strong>empathize and understand</strong> their experiences in depth through a User Journey. This helped identify not only their <strong>frustrations</strong> but also the <strong>customer loyalty opportunities</strong>.</p>

                            <img src={UserJourneyEN} alt="UserJourneyEN" />
                            <p>As illustrated in the Journey Map, <strong>two crucial opportunities</strong> were identified to improve the user experience and enhance customer loyalty.</p>

                            <h3>Opportunity 1</h3>
                            <p>At the moment when <strong>the user hesitates</strong> between different food apps, an opportunity arises. The user needs to be <strong>motivated</strong> to use our app. Even before or as the app opens, the user should perceive that they have something to gain by using our app. That's why we decided to highlight <strong>the existence of a loyalty system</strong> on the 'Home page' that allows users to get free products.</p>

                            <h3>Opportunity 2</h3>
                            <p>Another opportunity was identified when the customer has just completed their order and <strong>is about to leave the app</strong>. This phase represents the best time to <strong>inform</strong> the customer that they have earned loyalty points, which they can use to <strong>get free products on their next order</strong> on the app, encouraging them to return to the app.</p>

                            <br />
                            <div class="title"><h2>User Flow</h2></div>
                            <p>To strengthen user engagement and loyalty, a <strong>gratification flow</strong> should be established to satisfy the customer every time they are on the app and also encourage them to return.</p>

                            <img src={UserFlowFr} alt="UserFlowFr" />

                            <p>As illustrated in the User Flow, the user is initially <strong>encouraged to place an order</strong> (so they can add free products by spending the points they’ve accumulated). Later, once they have placed an order, they are <strong>motivated to return</strong> to the app since they’ve earned loyalty points <strong>to use during their next visit</strong>. This creates a <strong>loop="true"</strong> that helps maintain ongoing user engagement.</p>
                        </div>
                    </div>



                </div>




            </div>


            <ProjectNav NextProject='/project-fleet' PrevProject='/project-odenlo' />
            <Footer />








        </ScrollToTop>
    )

}
